import React from 'react';
import { Features } from '@hpi-sox/hpstellar-core';

import withPageComponents from '../../../page/components/with-page-components';
import { formatMetricValue } from '../../../metrics/metrics-helpers';
import useTestFlags from '../../../abtest/useTestFlags';
import { Helpers } from '../../../core/src/helpers';

const exclusiveFeatures = ({
    exclusiveFeatures,
    category,
    expandBtnText = 'See more features',
    collapseBtnText = 'See less features',
    title = 'Features',
}) => {
    const { richContent, features } = !!exclusiveFeatures ? exclusiveFeatures : {};

    if (richContent) {
        return <div id="features" dangerouslySetInnerHTML={Helpers.createMarkup(richContent)} />;
    }

    if (!features) {
        return null;
    }

    return (
        <div className="pdp-features">
            <Features
                features={features.map(f => ({
                    ...f,
                    description: <span dangerouslySetInnerHTML={Helpers.createMarkup(f.description)} />,
                }))}
                theme={category}
                gtmActions={
                    new Map([
                        [
                            'expandAction',
                            {
                                gtmCategory: 'linkClick',
                                gtmId: 'product',
                                gtmValue: formatMetricValue(expandBtnText),
                            },
                        ],
                    ])
                }
                accordionProps={{ size: 'small' }}
                translations={{
                    Features: {
                        collapseBtnText: collapseBtnText,
                        expandBtnText: expandBtnText,
                        mobileExpandBtnText: 'Features',
                    },
                }}
                title={title}
                className="pdp-features-wrapper"
                classes={{
                    columnsWrapper: 'columnsWrapper',
                }}
                accordionTitleProps={{
                    TypographyProps: { variant: 'orionSubtitleLarge' },
                }}
            />
        </div>
    );
};

export default withPageComponents(exclusiveFeatures, { components: ['exclusiveFeatures'] });
